import { render, staticRenderFns } from "./vTable.vue?vue&type=template&id=330d713e&scoped=true&"
import script from "./vTable.vue?vue&type=script&lang=js&"
export * from "./vTable.vue?vue&type=script&lang=js&"
import style0 from "./vTable.vue?vue&type=style&index=0&id=330d713e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d713e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330d713e')) {
      api.createRecord('330d713e', component.options)
    } else {
      api.reload('330d713e', component.options)
    }
    module.hot.accept("./vTable.vue?vue&type=template&id=330d713e&scoped=true&", function () {
      api.rerender('330d713e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/vTable.vue"
export default component.exports